import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { AxiosError } from 'axios'

import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateReturnLoss from '@/modules/promotion/api/hooks/useMutateCreateReturnLoss'
import { CreateReturnLossRequest } from '@/modules/promotion/type'
import ReturnLossForm from '../../../ReturnLossForm'
import { ProviderResolutionConflictDialog } from '../../../ProviderResolutionConflictDialog'

export default function CreateReturnLossForm() {
	const navigate = useNavigate()
	const [conflictDialogOpen, setConflictDialogOpen] = useState(false)
	const [conflictMessage, setConflictMessage] = useState('')

	const { mutate: createReturnLoss } = useMutationCreateReturnLoss({
		onSuccess: () => {
			toast.success('สร้างกิจกรรมคืนยอดเสียสำเร็จ')
			navigate('/operator/return-loss')
		},
		onError: (error) => {
			const axiosError = error as unknown as AxiosError<{
				message: string
				errorCode: string
			}>

			// Check if it's a provider resolution conflict error
			if (
				axiosError.isAxiosError &&
				axiosError.response?.data?.errorCode === 'PROVIDER_RESOLUTION_CONFLICT'
			) {
				setConflictMessage(axiosError.response.data.message)
				setConflictDialogOpen(true)
				return
			}

			// For other errors, show toast
			showErrorToast(error)
		},
	})

	const handleSubmit = (payload: CreateReturnLossRequest) => {
		createReturnLoss({ payload })
	}

	return (
		<>
			<ReturnLossForm mode="create" onSubmit={handleSubmit} />
			<ProviderResolutionConflictDialog
				isOpen={conflictDialogOpen}
				onClose={() => setConflictDialogOpen(false)}
				message={conflictMessage}
			/>
		</>
	)
}
